<forge-time-picker step="10" [disabled]="isViewOnly" [attr.allow-seconds]="allowSeconds"
    [attr.use-24-hour-time]="time24Hour">
    <forge-text-field [ngClass]="{'dense-input': dense || compact, 'cell-edit': forCellEdit}" [density]="density"
        [required]="isRequired" [attr.label-position]="LabelPosition" [attr.shape]="forCellEdit ? 'squared' : null">
    <input #input [id]="controlId" type="text" [(ngModel)]="valueModel" focusOnLoad [propertyMetadata]="propertyMetadata" [forCellEdit]="forCellEdit"
            [propertyMetadata]="propertyMetadata" [forCellEdit]="forCellEdit" [disabled]="isViewOnly"
            [required]="isRequired" (blur)="fireValueChanged()" (input)="onInputChange()"
            attr.telemetry="Time picker-{{Label}}" [name]="Name" placeholder="hh:mm AM" (keydown)="onKeyDown($event)">
      <label [for]="controlId">{{Label}}</label>
        @if (hint && !dense && !compact) {
        <span slot="support-text">{{hint}}</span>
        }
        @if (error && !dense && !compact) {
        <span slot="support-text" class="error-red">{{error}}</span>
        }
        @if (showSpinner) {
        <forge-circular-progress class="metadata-input--spinner" slot="end">
        </forge-circular-progress>
        }
    </forge-text-field>
</forge-time-picker>